function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { twMerge } from "@stereoagency/tailwind-config";
import React, { useRef, useState } from "react";
import { EntryAnimation } from "../../atoms";
var letters = Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ");
export default function AlphabeticalMobileFilter(param) {
    var include = param.include, className = param.className, onSelect = param.onSelect;
    var ref = useRef(null);
    var pointerTypeRef = useRef("mouse");
    var _useState = _sliced_to_array(useState(null), 2), highlighted = _useState[0], setHighlighted = _useState[1];
    var handlePointerLeave = function(event) {
        if (event.pointerType === "touch" && highlighted) {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(highlighted);
        }
        setHighlighted(null);
    };
    var handlePointerMove = function(event) {
        pointerTypeRef.current = event.pointerType;
        if (event.pointerType === "touch") {
            event.preventDefault();
            var el = document.elementFromPoint(event.clientX, event.clientY);
            var letter = el === null || el === void 0 ? void 0 : el.textContent;
            if (letter) {
                setHighlighted(letter);
            }
        }
    };
    var handleButtonClick = function(event) {
        var letter = event.currentTarget.textContent;
        if (letter && pointerTypeRef.current !== "touch") {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(letter);
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: twMerge("touch-none", className),
        onPointerLeave: handlePointerLeave,
        onPointerMove: handlePointerMove
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        className: "flex flex-col justify-center items-start text-center"
    }, letters.map(function(letter) {
        if ((include === null || include === void 0 ? void 0 : include.length) && !include.includes(letter)) return null;
        return /*#__PURE__*/ React.createElement("button", {
            key: letter,
            type: "button",
            className: twMerge("w-[2.25rem] h-[2.25rem] rounded-full bg-bg-subtle -mt-4 first-of-type:mt-0", highlighted === letter && "text-fg-inverted bg-red-700 z-10 scale-125"),
            onClick: handleButtonClick
        }, /*#__PURE__*/ React.createElement("span", {
            className: "font-heading font-semibold text-body-small"
        }, letter));
    })));
}

//# sourceMappingURL=AlphabeticalMobileFilter.js.map